import { render, staticRenderFns } from "./ReportXslx.vue?vue&type=template&id=2e6b37d6&"
import script from "./ReportXslx.vue?vue&type=script&lang=js&"
export * from "./ReportXslx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports